import { render, staticRenderFns } from "./StudentConduct.vue?vue&type=template&id=4baae57f"
import script from "./StudentConduct.vue?vue&type=script&lang=js"
export * from "./StudentConduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports